import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
    *,
    :before,
    :after {
        box-sizing: border-box;
    }

    body,
    div,
    dl,
    dt,
    dd,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    pre,
    form,
    fieldset,
    input,
    textarea,
    p,
    blockquote,
    th,
    td {
        margin: 0;
        padding: 0;
    }

    body,
    button,
    textarea {
        font-family: 'Montserrat', sans-serif;
        font-weight: 400;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.02em;
    }

    button {
        border: 0;
        background-color: transparent;
        outline: none;
    }

    iframe {
        width: 100%;
    }
`

export default GlobalStyle